import { Link } from 'react-router-dom';
import MangaCard from '@/components/base/MangaCard';
import { mangas } from '@/mocks/mangas';

export default function HotMangas() {
  const hot = mangas.filter((m) => m.featured);
  return (
    <section id="tracking" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
              <i className="ri-fire-fill" /> 热门连载
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950">本周热门连载漫画</h2>
            <p className="mt-2 text-sm text-foreground-600">大家都在追的高人气作品，追更热度实时更新</p>
          </div>
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看更多分类 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hot.map((m) => (
            <MangaCard key={m.id} manga={m} />
          ))}
        </div>
      </div>
    </section>
  );
}